module.exports = __webpack_public_path__ + "static/media/SELBOURNE 3.680b4f0d.jpg";